// LangContext.ts
import { createContext } from "react";

export const LangContext = createContext<string>("he");
